import { SolutionCard } from 'components/SolutionCard/SolutionCard';
import './styles.scss';
import GradientText from 'components/GradientText';
import { useSelector } from 'react-redux';
import { selectHomepage } from 'store/slices/HomepageSlice';
import { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useMediaQuery from 'hooks/useMediaQuery';
import solutionsVideo from 'assets/uniferx_no_gradient.mp4';

gsap.registerPlugin(ScrollTrigger);

const Solutions = () => {
    const { banner_cards = [], banner_title } = useSelector(selectHomepage);
    const container = useRef();
    const isTablet = useMediaQuery('max-width: 1023px');

    const speed = isTablet ? [-250, -180, -220, -270] : [-300, -200, -150, -270];
    const videoRef = useRef(null);
    const solutionsRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        const block = solutionsRef.current;
        if (!video || !block) return;

        const handleScroll = () => {
            if (block.getBoundingClientRect().bottom <= window.innerHeight) {
                video.play();
                window.removeEventListener('scroll', handleScroll);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useGSAP(
        () => {
            let targets = gsap.utils.toArray(['.solution-card']);
            targets.forEach((item, index) => {
                gsap.to(item, {
                    yPercent: speed[index],
                    ease: 'none',
                    scrollTrigger: {
                        trigger: '.solutions',
                        scrub: 1,
                    },
                });
            });
        },
        { scope: container },
    );

    return (
        <section id="information-wrapper" className="container" ref={container}>
            <div className="solutions" ref={solutionsRef}>
                <video
                    ref={videoRef}
                    className="solutions__bg-video"
                    src={solutionsVideo}
                    muted
                    playsInline
                />
                <GradientText size="super-small" textColor="white" className="has-animation">
                    <span dangerouslySetInnerHTML={{ __html: banner_title }} />
                </GradientText>
                <div>
                    {banner_cards.map(item => (
                        <SolutionCard key={item.title} image={item.icon} numbers={item.title} description={item.text} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Solutions;
